export default __webpack_public_path__ + "static/media/light.16eacdb6.png";